import React, { useState, useLayoutEffect, useEffect } from "react";
import "./styles/main.css";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Guide from "./Utils/Guide";

import SubscribersBoard from "./components/SubscribersBoard";
import Head from "./components/Desktop/Head";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "./store/actions";

const App = () => {
	let [width, setWidth] = useState( window.innerWidth );
	const [tourIsOpen, setTourIsOpen] = useState( true );

	const initChat = (d, w, m) => {
		window.supportAPIMethod = m;
		var s = d.createElement( "script" );
		s.type = "text/javascript";
		s.id = "supportScript";
		s.charset = "utf-8";
		s.async = true;
		// var id = '79804a671f2e21b9576ff045316601df';  // My
		// var id = '9707775822347b3d7ec56fbe8e09054f'; // Sania's
		var id = process.env.REACT_APP_SUPPORT_CHAT_ID;
		s.src = "https://lcab.talk-me.ru/support/support.js?h=" + id;
		var sc = d.getElementsByTagName( "script" )[0];
		w[m] = w[m] || function() { ( w[m].q = w[m].q || [] ).push( arguments ); };
		if ( sc ) sc.parentNode.insertBefore( s, sc );
		else d.documentElement.firstChild.appendChild( s );
	};

	const { t, i18n } = useTranslation( "head" );
	const { language } = useSelector( store => store );
	const dispatch = useDispatch();
	const setDefaultLanguage = () => {
		const defaultLang = localStorage.getItem( "sub_lang" );
		if ( !!defaultLang ) {
			dispatch( setLanguage( defaultLang ) );
		} else {
			const userLanguage = window.navigator.language;

			if ( userLanguage === "ru" ) dispatch( setLanguage( "ru" ) );
			if ( userLanguage === "en" || userLanguage === "en-US" ) dispatch( setLanguage( "en" ) );
			if ( userLanguage === "es" ) dispatch( setLanguage( "es" ) );
		}
	};

	useEffect( () => {
		if ( window.TalkMe && window.MeTalk ) {
			setDefaultLanguage();
			window.TalkMeSetup = {
				language: language
			};
			// initChat( document, window, 'TalkMe' );
			window.TalkMe( "hideTrigger" );
		}
	}, [window.TalkMe] );

	useEffect( () => {
		if ( language !== "ru" ) {
			window.TalkMeSetup = {
				language: language
			};
			window.TalkMe( "reload" );

			window.TalkMe( "hideTrigger" );
		}

		// 		 window.TalkMe( 'destroy' );

		// window.TalkMe("setCallback", 'closeSupport' , () => window.TalkMe("hideTrigger"));

		i18n.changeLanguage( language );
	}, [language] );

	useLayoutEffect( () => {
		const updateWidth = () => setWidth( window.innerWidth );

		window.addEventListener( "resize", updateWidth );

		updateWidth();
	} );

	const [is404, setIs404] = useState( false );
	return (
		<div>
			<Helmet>
				<title>{t( "Таблица лидеров" )}</title>
			</Helmet>
			{" "}
			{width >= 1224 ? is404 ? null : <Head/> : null}
			<div
				className={is404 ? "error_container_mobile" : "main_container_mobile"}
			>
				{/*<Guide tourIsOpen={ tourIsOpen } setTourIsOpen={ setTourIsOpen }/>*/}
				<SubscribersBoard is404={setIs404}/>
			</div>
		</div>
	);
};

export default App;
